import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import posthog from 'posthog-js';
import { isObservabilityEnabled } from '../config';
import { SentryInstance } from './instance';

SentryInstance.init({
  enabled: isObservabilityEnabled(),
  dsn: 'https://18e8e601f6352c29b414b11510564179@o4507699183353856.ingest.us.sentry.io/4507699185319936',
  integrations: [
    SentryInstance.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
      traceFetch: true,
      traceXHR: true,
      trackFetchStreamPerformance: true,
      enableHTTPTimings: true,
      ignoreResourceSpans: ['resource.script', 'resource.css', 'resource.img'],
    }),
    SentryInstance.breadcrumbsIntegration({
      console: true,
      dom: false,
      fetch: false,
      history: true,
      xhr: true,
    }),
    SentryInstance.graphqlClientIntegration({
      endpoints: [/\/graphql$/],
    }),
    {
      name: 'posthog-js',
      processEvent: (event) => {
        if (!event.tags) event.tags = {};
        const personUrl = posthog.requestRouter.endpointFor(
          'ui',
          `/project/${posthog.config.token}/person/${posthog.get_distinct_id()}`,
        );
        event.tags['PostHog Person URL'] = personUrl;
        if (posthog.sessionRecordingStarted()) {
          event.tags['PostHog Recording URL'] = posthog.get_session_replay_url({
            withTimestamp: true,
          });
        }

        return event;
      },
    },
  ],
  //? disable replays, check posthog for recordings
  replaysSessionSampleRate: 0,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.copera\.ai/],
});
